<div class="content">
  <div class="content-container">
    <div class="content-container_select_input">
      <div class="countryPhoneSelect_wrapper">
        <select a11y_Select class="countryPhoneSelect" [(ngModel)]="selectedCode"
          (change)="SelectCodeChangeHandler($event)">
          <ng-container *ngFor="let country of countryData">
            <option [value]="country.data_code" [selected]="country.data_code === selectedCode">
              {{country.data_country}}</option>
          </ng-container>
        </select>
        <div class="countryPhoneSelect_choice">
          <span class="phoneCode">{{selectedCode}}</span>
          <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-pfeil-unten-voll"></div>
        </div>
      </div>
      <div class="phone-input phone-input_wrapper">
        <div class="ya-input-wrapper ">
          <input a11y_Input class="ya-input-text" placeholder=" " [formControl]="inputFormControl" autocomplete="tel">
          <span>{{numberTemplate}}</span>
          <ng-container *ngIf="inputFormControl.touched && inputFormControl.invalid">
            <ng-container *ngIf="inputFormControl.errors">
              <ng-container *ngIf="inputFormControl.errors.minlength">
                <ya-errorvalidation [controlValidation]="inputFormControl.errors.minlength"
                  errorMessage="phPhoneInput_Min_Error"></ya-errorvalidation>
              </ng-container>
              <ng-container *ngIf="inputFormControl.errors.maxlength">
                <ya-errorvalidation [controlValidation]="inputFormControl.errors.maxlength"
                  errorMessage="phPhoneInput_Max_Error"></ya-errorvalidation>
              </ng-container>
              <ng-container *ngIf="inputFormControl.errors.pattern">
                <ya-errorvalidation [controlValidation]="inputFormControl.errors.pattern"
                  errorMessage="phPhoneInput_NumbersOnly_Error"></ya-errorvalidation>
              </ng-container>
            </ng-container>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>